import script from "./AddSchedulePackageModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddSchedulePackageModal.vue?vue&type=script&setup=true&lang=ts"

import "./AddSchedulePackageModal.vue?vue&type=style&index=0&id=0926b456&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0926b456"]])

export default __exports__